export default __webpack_public_path__ + "9493e04003d0ce024977d4d94e0fca74.png";